import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { BackofficeOrganizationResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Query = {
  id: string
}

type Response = DataResponse<z.infer<typeof BackofficeOrganizationResponseDataSchema>>

export const getBackofficeOrganizationQueryKey = (query: Query) => ["backofficeOrganization", query]

type Props = {
  query: Query
}

export const getBackofficeOrganizationQuery = ({ query }: Props) => {
  return queryOptions({
    queryKey: getBackofficeOrganizationQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/backoffice/organizations/${query.id}`)
      return data.data
    },
  })
}
